(() => {
  if (window.GlowryteAbout?.initialized) return;

  const state = { trigger: null };

  function galleryItems(gallery) {
    return [...gallery.querySelectorAll('[data-gr-gallery-open]')];
  }

  function showImage(gallery, index) {
    const items = galleryItems(gallery);
    if (!items.length) return;
    const normalized = (index + items.length) % items.length;
    const item = items[normalized];
    const source = item.querySelector('img');
    const dialog = gallery.querySelector('[data-gr-lightbox]');
    if (!source || !dialog) return;
    dialog.dataset.index = String(normalized);
    const image = dialog.querySelector('[data-gr-lightbox-image]');
    image.src = source.currentSrc || source.src;
    image.alt = source.alt || '';
    image.width = Number(item.dataset.grImageWidth);
    image.height = Number(item.dataset.grImageHeight);
    dialog.querySelector('[data-gr-lightbox-caption]').textContent = source.alt || '';
  }

  function openGallery(trigger) {
    const gallery = trigger.closest('[data-gr-gallery]');
    const dialog = gallery?.querySelector('[data-gr-lightbox]');
    if (!gallery || !dialog) return;
    state.trigger = trigger;
    showImage(gallery, Number(trigger.dataset.index || 0));
    dialog.showModal();
    document.documentElement.classList.add('gr-about-lightbox-open');
    dialog.querySelector('[data-gr-close]')?.focus();
  }

  function closeGallery(dialog) {
    if (!dialog?.open) return;
    dialog.close();
    document.documentElement.classList.remove('gr-about-lightbox-open');
    state.trigger?.focus();
    state.trigger = null;
  }

  document.addEventListener('click', (event) => {
    const faqTrigger = event.target.closest('[data-gr-about-faq] .gr-about-faq__trigger');
    if (faqTrigger) {
      const panel = document.getElementById(faqTrigger.getAttribute('aria-controls'));
      if (panel) {
        const expanded = faqTrigger.getAttribute('aria-expanded') === 'true';
        faqTrigger.setAttribute('aria-expanded', String(!expanded));
        panel.hidden = expanded;
      }
      return;
    }

    const opener = event.target.closest('[data-gr-gallery-open]');
    if (opener) return openGallery(opener);

    const dialog = event.target.closest('[data-gr-lightbox]');
    if (!dialog) return;
    if (event.target.closest('[data-gr-close]') || event.target === dialog) return closeGallery(dialog);
    const gallery = dialog.closest('[data-gr-gallery]');
    const index = Number(dialog.dataset.index || 0);
    if (event.target.closest('[data-gr-prev]')) showImage(gallery, index - 1);
    if (event.target.closest('[data-gr-next]')) showImage(gallery, index + 1);
  });

  document.addEventListener('keydown', (event) => {
    const dialog = document.querySelector('[data-gr-lightbox][open]');
    if (!dialog) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeGallery(dialog);
    }
    const gallery = dialog.closest('[data-gr-gallery]');
    const index = Number(dialog.dataset.index || 0);
    if (event.key === 'ArrowLeft') showImage(gallery, index - 1);
    if (event.key === 'ArrowRight') showImage(gallery, index + 1);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector?.('[data-gr-lightbox][open]')) document.documentElement.classList.remove('gr-about-lightbox-open');
  });

  window.GlowryteAbout = { initialized: true };
})();
